import { styled } from 'parkdepot-shared/theme'

export const Wrapper = styled<'div', { $cardShown: boolean }>('div', ({ $cardShown }) => ({
    position: 'fixed',
    bottom: $cardShown ? '10rem' : '10rem',
    right: '1.6rem',
    display: 'flex',
    height: '5rem',
    padding: '1.5rem',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '6px',
    borderRadius: '24px',
    flexShrink: 0,
    backgroundColor: '#5046E8'
}))
